// Number of days with more than 0.1 inch of precipitation at Grand Canyon Village
// https://www.ncdc.noaa.gov/cdo-web/datasets/NORMAL_MLY/stations/GHCND:USC00023596/detail
const precipitationDaysByMonthIndex = [4, 4, 5, 3, 2, 1, 4, 5, 3, 3, 3, 3];
export default precipitationDaysByMonthIndex;
